<template>
  <div id="footer-scroll" class="g-page">
    <section class="property-owner" v-if="$route.name === 'home'">
      <div class="container-fluid plr-80">
        <div class="row">
          <div class="col-12 text-center">
            <h2 class="section-title color-fff">
              {{ $t("footer.areYouPropertyOwner") }}
            </h2>
            <p>{{ $t("footer.areYouPropertyOwnerContent") }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center list-property">
            <a target="_blank" href="https://admin.gloveler.com/register">{{ $t("footer.listYourProperty") }}</a>
            <a @click="openHelp" href="#"> {{ $t("footer.getInTouch") }} </a>
          </div>
        </div>
      </div>
    </section>

    <hr class="footer-divider">

    <section
      class="follow"
      v-if="
        $route.name &&
        showSocials &&
        !['terms-of-use', 'legal-notice', 'privacy-policy', '404'].includes(
          $route.name
        )
      "
    >
      <div class="container-fluid plr-80">
        <div class="row">
          <div class="col-12 text-center">
            <h2 class="section-title color-444">
              {{ $t("footer.followBrand", { brand: currentConfigKey('title') }) }}
            </h2>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center">
            <ul class="social-icons d-flex" style="flex-wrap: wrap">
              <li class="mb-2" v-if="currentConfigKey('socials.facebook')">
                <a
                  :href="currentConfigKey('socials.facebook')"
                  target="_blank"
                  class="g-social"
                  ><i class="fa fa-facebook" aria-hidden="true"></i
                ></a>
              </li>
              <li class="mb-3" v-if="currentConfigKey('socials.twitter')">
                <a
                  :href="currentConfigKey('socials.twitter')"
                  target="_blank"
                  class="g-social"
                  ><i class="fa fa-twitter" aria-hidden="true"></i
                ></a>
              </li>
              <li class="mb-3" v-if="currentConfigKey('socials.mail')">
                <a
                  :href="currentConfigKey('socials.mail')"
                  target="_blank"
                  class="g-social"
                  ><i class="fa fa-envelope" aria-hidden="true"></i
                ></a>
              </li>
              <li class="mb-3" v-if="currentConfigKey('socials.phone')">
                <a
                  :href="currentConfigKey('socials.phone')"
                  target="_blank"
                  class="g-social"
                  ><i class="fa fa-phone" aria-hidden="true"></i
                ></a>
              </li>
              <li class="mb-3" v-if="currentConfigKey('socials.linkedin')">
                <a
                  :href="currentConfigKey('socials.linkedin')"
                  target="_blank"
                  class="g-social"
                  ><i class="fa fa-linkedin" aria-hidden="true"></i
                ></a>
              </li>
              <li class="mb-3" v-if="currentConfigKey('socials.instagram')">
                <a
                  :href="currentConfigKey('socials.instagram')"
                  target="_blank"
                  class="g-social"
                  ><i class="fa fa-instagram" aria-hidden="true"></i
                ></a>
              </li>
              <li class="mb-3" v-if="currentConfigKey('socials.snapchat')">
                <a
                  :href="currentConfigKey('socials.snapchat')"
                  target="_blank"
                  class="g-social"
                  ><i class="fa fa-snapchat-ghost" aria-hidden="true"></i
                ></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="main-footer">
      <div class="container-fluid plr-80">
        <div class="row">
          <div class="col-md-3 footer-logo col-lg-3">
            <component
              :is="
                currentConfigKey('logoLink', '/').startsWith('/')
                  ? 'router-link'
                  : 'a'
              "
              :to="currentConfigKey('logoLink', '/')"
              :href="currentConfigKey('logoLink', '/')"
            >
              <img :src="currentConfigKey('logo')" class="app-logo" alt="" />
            </component>
            <p class="copyright">
              © {{ $t("footer.copyright") }} {{ new Date().getFullYear() }}
            </p>
          </div>
          <div
            class="col footer-list"
            v-if="currentConfigKey('footerSections.company.display')"
          >
            <h4>
              {{ $t(currentConfigKey("footerSections.company.titleKey")) }}
            </h4>
            <ul>
              <li v-if="currentConfigKey('footerLinks.aboutUs')">
                <a href="/about-us">{{ $t("footer.aboutUs") }}</a>
              </li>
              <li
                v-for="{ titleKey, url, newTab } in currentConfigKey(
                  'customFooterLinks.company',
                  []
                )"
                :key="titleKey"
              >
                <a :href="url" :target="newTab ? '_blank' : '_self'">{{
                  $t(titleKey)
                }}</a>
              </li>
            </ul>
          </div>
          <div
            class="col footer-list"
            v-if="currentConfigKey('footerSections.legal.display')"
          >
            <h4>{{ $t(currentConfigKey("footerSections.legal.titleKey")) }}</h4>
            <ul>
              <li v-if="currentConfigKey('footerLinks.termsOfUse')">
                <a href="/terms-of-use">{{ $t("footer.termsOfUse") }}</a>
              </li>
              <li v-if="currentConfigKey('footerLinks.privacyPolicy')">
                <a href="/privacy-policy">{{ $t("footer.privacyPolicy") }}</a>
              </li>
              <li v-if="showCookieSettings">
                <a href="#" @click.prevent="openCookieSettings">{{
                  $t("privacyPolicy.cookieSettings")
                }}</a>
              </li>
              <li v-if="currentConfigKey('footerLinks.legalNotice')">
                <a href="/legal-notice">{{ $t("footer.legalNotice") }}</a>
              </li>
              <li
                v-for="{ titleKey, url, newTab } in currentConfigKey(
                  'customFooterLinks.legal',
                  []
                )"
                :key="titleKey"
              >
                <a :href="url" :target="newTab ? '_blank' : '_self'">{{
                  $t(titleKey)
                }}</a>
              </li>
            </ul>
          </div>
          <div
            class="col footer-list"
            v-if="currentConfigKey('footerSections.information.display')"
          >
            <h4>
              {{ $t(currentConfigKey("footerSections.information.titleKey")) }}
            </h4>
            <ul>
              <li v-if="currentConfigKey('footerLinks.contact')">
                <a href="#">{{ $t("footer.contact") }}</a>
              </li>
              <li
                v-for="{ titleKey, url, newTab } in currentConfigKey(
                  'customFooterLinks.information',
                  []
                )"
                :key="titleKey"
              >
                <a :href="url" :target="newTab ? '_blank' : '_self'">{{
                  $t(titleKey)
                }}</a>
              </li>
            </ul>
          </div>
          <div
            class="col-md-3 footer-list"
            v-if="currentConfigKey('footerSections.gloveler.display')"
          >
            <h4>
              {{ $t(currentConfigKey("footerSections.gloveler.titleKey")) }}
            </h4>
            <ul>
              <li v-if="currentConfigKey('footerLinks.buildBookingEngine')">
                <a href="/build-booking-engine">{{
                  $t("footer.bedAndBreakfast")
                }}</a>
              </li>
              <li v-if="currentConfigKey('footerLinks.blog')">
                <a href="#">{{ $t("footer.glovelerBlog") }}</a>
              </li>
              <li v-if="currentConfigKey('footerLinks.listProperty')">
                <a href="/list-accomodation">{{
                  $t("footer.listAccomodationFree")
                }}</a>
              </li>
              <li
                v-for="{ titleKey, url, newTab } in currentConfigKey(
                  'customFooterLinks.gloveler',
                  []
                )"
                :key="titleKey"
              >
                <a :href="url" :target="newTab ? '_blank' : '_self'">{{
                  $t(titleKey)
                }}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="row mob-block">
          <div class="col-12 text-center">
            <p class="copyright">
              © {{ $t("footer.copyright") }} {{ new Date().getFullYear() }}
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { currentConfigKey } from "../helpers/theme";
import { isCookiesAllowed, hasGoogleAnalyticsConfigured } from "../helpers/consent";
import store from "../store";

export default {
  name: "Footer",
  methods: {
    currentConfigKey,
    openHelp() {
      document.getElementById("zammad-feedback-form").click();
    },
    openCookieSettings() {
      document.dispatchEvent(new Event("openCookieConsent"));
    },
  },
  computed: {
    showSocials() {
      const socials = currentConfigKey("socials", {});
      return Object.values(socials).some((val) => val.trim() !== "");
    },
    showCookieSettings() {
      const config =
        store.state.config.currentConfig || store.state.config.defaultConfig || {};
      return hasGoogleAnalyticsConfigured(config) && isCookiesAllowed(config);
    },
  },
};
</script>
